import { inject, provide, type App } from 'vue'
import { useEsimStore } from '~/stores/esimStore'

export type WidgetMode = 'default' | 'search' | 'steps' | 'checkout'

export type WidgetModeOpt = Partial<{
  mode: WidgetMode
  instanceId: string
}>

const KEY = Symbol('useWidgetMode')

const getWithDefaults = (opt: WidgetModeOpt = {}) => {
  const { mode = 'default', instanceId = mode } = opt
  return { mode, instanceId }
}

export const useWidgetMode = () => {
  return inject(KEY, getWithDefaults())
}

useWidgetMode.provide = (opt: WidgetModeOpt = {}, app?: App) => {
  const value = getWithDefaults(opt)
  app ? app.provide(KEY, value) : provide(KEY, value)
}

export const useStore = () => {
  const { instanceId } = useWidgetMode()
  return useEsimStore(instanceId)
}